import type { ClimateZone, RainRecommendation } from '../types';

export type RainRecommendationKey = keyof Omit<RainRecommendation, 'climate_zone'>;
type RecommendedClimateZone = Exclude<ClimateZone, 'polar'>;

// Form fields each recommended value is applied to as default.
export const RAIN_RECOMMENDATION_FIELDS: Record<RainRecommendationKey, string[]> = {
  rain_threshold: ['rain_threshold', 'soiling_ratio_operational.rain_threshold', 'soiling_ratio_operational_ex_post.rain_threshold'],
  rain_efficiency: [
    'rain.rain_efficiency',
    'soiling_ratio_operational.rain_efficiency',
    'soiling_ratio_operational_ex_post.rain_efficiency',
  ],
};

export const CLIMATE_ZONE_LABELS: Record<RecommendedClimateZone, string> = {
  tropical: 'Tropical',
  arid: 'Arid',
  temperate: 'Temperate',
  cold: 'Cold (continental)',
};

export const RAIN_RECOMMENDATION_UNITS: Record<RainRecommendationKey, string> = {
  rain_threshold: 'mm/day',
  rain_efficiency: '',
};
